import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { nextSteps } from "@/lib/projectNextSteps";

// Blocking next steps across every active project, plus the crew conflicts that feed them.
export const blockerRows = (projects = [], conflicts = []) =>
  projects
    .map((p) => {
      const steps = nextSteps({ p, invoices: p.invoices || [], conflicts });
      return {
        p,
        blocks: steps.filter((s) => s.level === "block"),
        warns: steps.filter((s) => s.level === "warn").length,
      };
    })
    .filter((r) => r.blocks.length);

export const blockerCount = (projects, conflicts) =>
  blockerRows(projects, conflicts).reduce((n, r) => n + r.blocks.length, 0);

let cache = { at: 0, projects: [], conflicts: [] };
const TTL = 3 * 60 * 1000;

/** Projects + conflicts behind "Needs a push", cached briefly so the sidebar badge is cheap. */
export const useAttention = (fresh = false) => {
  const [state, setState] = useState({
    projects: cache.projects,
    conflicts: cache.conflicts,
    loading: !cache.at,
  });
  const load = useCallback(async () => {
    const safe = (p) => p.catch(() => ({ data: null }));
    const [a, c] = await Promise.all([safe(api.get("/projects/attention")), safe(api.get("/schedule/crew-conflicts"))]);
    cache = { at: Date.now(), projects: a.data?.projects || [], conflicts: c.data?.conflicts || [] };
    setState({ projects: cache.projects, conflicts: cache.conflicts, loading: false });
  }, []);
  useEffect(() => {
    if (fresh || Date.now() - cache.at > TTL) load();
  }, [load, fresh]);
  return { ...state, reload: load };
};
